"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MonthAndYear = exports.Heading = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _theme = require("@atlaskit/theme");

var Heading = _styledComponents.default.div.withConfig({
  displayName: "Heading",
  componentId: "kci65o-0"
})(["\n  display: flex;\n  padding: 0 0 8px 0;\n  font-weight: bold;\n  color: ", ";\n"], _theme.colors.N800);

exports.Heading = Heading;

var MonthAndYear = _styledComponents.default.div.withConfig({
  displayName: "Heading__MonthAndYear",
  componentId: "kci65o-1"
})(["\n  flex-basis: 100%;\n  text-align: center;\n"]);

exports.MonthAndYear = MonthAndYear;